import { render, staticRenderFns } from "./PopupEditSetup.vue?vue&type=template&id=715b21ad&scoped=true&"
import script from "./PopupEditSetup.vue?vue&type=script&lang=js&"
export * from "./PopupEditSetup.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditSetup.vue?vue&type=style&index=0&id=715b21ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b21ad",
  null
  
)

export default component.exports